import React, { forwardRef } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

/**
 * Flow brand exclusive icon
 */
export const MapFlagFilledIcon: React.FC<SvgIconProps> = forwardRef((props, ref) => {
  return (
    <SvgIcon viewBox="2 2 20 20" ref={ref} {...props}>
      <path d="M6.26 14.14V20.38H4.58V4.08H13.4L9.6 14.14H6.26ZM10.6 16.22L14.4 6.16H19.42V16.22H10.6Z" />
    </SvgIcon>
  );
});
